import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid';

interface Page {
  label: string;
  href: string;
}

export default function Breadcrumb({ pages }: { pages: Page[] }): JSX.Element {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        <li>
          <div>
            <a href="/" className="text-gray-400 hover:text-gray-500">
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </a>
          </div>
        </li>
        {pages.map(page => (
          <li key={page.label}>
            <div className="flex items-center">
              <ChevronRightIcon
                className="h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <a
                href={page.href || ''}
                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              >
                {page.label}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
